/* eslint-disable react/jsx-props-no-spreading */
import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CHECK_PATH =
    "M2.77129 10.3977C2.1818 9.73539 1.70561 9.08756 1.24562 8.46016C0.825296 7.88967 0.460841 7.28006 0.157294 6.63976C-0.032695 6.25124 -0.116788 5.85784 0.29474 5.60491C1.47414 4.88012 1.71583 5.57217 2.35687 6.37517C2.73685 6.85099 3.29716 7.63561 3.64823 8.13136C3.98358 8.60477 4.3924 7.75032 4.5556 7.50922C5.13566 6.65237 6.64327 4.55464 7.26628 3.77924C7.85773 3.04314 9.76681 0.980981 10.1227 0.652985C10.4256 0.373701 11.0652 -0.238873 11.4953 0.0990579C11.9472 0.454119 12.168 1.12905 11.8503 1.56789C11.2971 2.3319 10.428 3.05868 9.82667 3.78615C8.60944 5.25872 7.45701 6.84603 6.35081 8.42649C5.97491 8.96357 5.44715 9.86309 5.11949 10.4455C4.50658 11.5352 3.96822 11.7425 2.77129 10.3977Z";

export const CheckboxUncheckedIcon = (props: React.ComponentProps<typeof SvgIcon>) => {
    const theme = useTheme();

    return (
        <SvgIcon {...props} height="22px" viewBox="0 0 24 24" width="22px">
            <rect
                fill={theme.palette.background.light}
                height="22"
                rx="4"
                ry="4"
                stroke="currentColor"
                strokeWidth="1.5"
                width="22"
                x="1"
                y="1"
            />
        </SvgIcon>
    );
};

export const CheckboxCheckedIcon = (props: React.ComponentProps<typeof SvgIcon>) => {
    const theme = useTheme();

    return (
        <SvgIcon {...props} height="22px" viewBox="0 0 24 24" width="22px">
            <rect
                fill={theme.palette.background.light}
                height="22"
                rx="4"
                ry="4"
                stroke="currentColor"
                strokeWidth="1.5"
                width="22"
                x="1"
                y="1"
            />
            <path d={CHECK_PATH} fill="currentColor" transform="translate(6, 6)" />
        </SvgIcon>
    );
};
